import { render, staticRenderFns } from "./ConfiGured.vue?vue&type=template&id=52c9b0a3&scoped=true"
import script from "./ConfiGured.vue?vue&type=script&lang=js"
export * from "./ConfiGured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c9b0a3",
  null
  
)

export default component.exports